module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/headers-styles/header-style3/header-style3.component.scss
// module id = ./src/app/features/headers-styles/header-style3/header-style3.component.scss
// module chunks = main